import { customBaseUrl, httpGet, httpPut } from '../store/http';

export const getLiveKeyRequests = async (page = 0, size = 10, merchantId = null) => {
  let url = `${customBaseUrl.integUrl}/api/v1/portal/keys/admin/live-key-requests?page=${page}&size=${size}`;
  if (merchantId) {
    url += `&merchantId=${merchantId}`;
  }
  return await httpGet(url);
};

export const reviewLiveKeyRequest = async (requestId, approved, comment) => {
  return await httpPut(
    `${customBaseUrl.integUrl}/api/v1/portal/keys/admin/live-key-requests/${requestId}`,
    { approved, comment }
  );
};
